import React, { Dispatch, useCallback, useContext, useEffect, useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useDispatch } from 'react-redux';
import { setAuthentication } from '../../store/actionCreators';
import IPage from '../../interfaces/page';
import Notification, { notificationImages } from '../../components/notifications/notification.component';
import instance from '../../api/api';
import { INotification, NotificationType } from '../../interfaces/notification';
import Icon from '@mdi/react';
import { mdiChevronRight  } from '@mdi/js';
import { Context } from '../home.page';
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import { setCookies } from '../../components/_helper/cookies';

const defaultNotificationValue : INotification = {icon:notificationImages.happiness, title:"", text:"", success:NotificationType.success}

/**
 * Inactive accout page for decased status users
 * @param props : unused for now
 * @returns void
 */
 const Verification: React.FunctionComponent<IPage> = props => {

    const [ code, setCode ] = useState<string>('');
    const [ notification, setNotification ] = useState<INotification>(defaultNotificationValue);
    const [ email, setEmail ] = useState<string>('');

    const updateLoggedInUserData = useContext(Context).setUserDetails;

    const navigate = useNavigate();
    const cookies = new Cookies();
    const { t } = useTranslation();

    const { lang } = useParams();

    const location: any = useLocation();

    useEffect(() => {
        if(lang) {
            i18n.changeLanguage(lang);
        }
        if(location.state) {
            if(location.state.email) {
                setEmail(location.state.email)
            }
            else {
                navigate(`/login${lang ? "/"+lang : ''}`);
            }
        }
        else {
            navigate(`/login${lang ? "/"+lang : ''}`);
        }
    }, [])

    //Remove notification from the screen after 5 seconds.
    function resetNotification() {
        setNotification(defaultNotificationValue)
    }

    /**
     * Redux functions to save if authentication was complete or not.
     */
    const dispatch: Dispatch<any> = useDispatch();
    const setAuth = useCallback((isAuthenticated: boolean) => dispatch(setAuthentication(isAuthenticated)), [dispatch])

    /**
     * Send the security code to the user.
     */
    async function handleConfirmation() {
        try {
            // send familyVip token for deletion to API
            const body = location.state.familyVip ? { token:code, email:email, sToken: location.state.familyVip } : location.state.invitation ? { token:code, email:email, invitation: location.state.invitation } : { token:code, email:email };
            let response = await instance.post('/verification/email', body);
            setCookies(response.data.token, response.data.refreshToken);
            localStorage.setItem('userid', response.data.user._id);
            updateLoggedInUserData(response.data.user);

            setNotification({icon:notificationImages.happiness, title:"Successful verification", text:"We will redirect you to finish your registration.", success:NotificationType.success});

            // Pass subscription data to registration-details page
            const subscriptionState = {
                referral: location.state.referral,
                familyVip: location.state.familyVip,
                newsletter: location.state.newsletter,
                email: email
            };

            setTimeout(() => {
                setAuth(true);
                navigate(`/registration-details${lang ? "/"+lang : ''}`, { state: subscriptionState });
            }, 2000)

        }
        catch(err) {
            setNotification({icon:notificationImages.crying, title:"Incorrect security code", text:"Please try again or click 'resend security code' for a new code.", success:NotificationType.problem});
        }
    }

    /**
     * Resend the security code to the user
     */
    async function reSendSecurityCode() {
        try {
            await instance.post('/verification/email/resend', { email:email });
            setNotification({icon:notificationImages.happiness, title:"Verification code sent", text:"Please check your e-mail.", success:NotificationType.success});
        }
        catch(err:any) {
            setNotification({icon:notificationImages.crying, title:"We couldn't send verification code", text: err?.response?.data || 'Unknown Error' , success:NotificationType.problem});
        }
    }

    return(
        <Container className="confirmation-container">
            <p className="confirm-title">{t("Confirm email")}</p>
            <p className="sub-text">{t("Enter the security code sent to:")} {email}</p>
            <Form.Group className="group">
                <input className="security-code" placeholder="Security code (8 digits)" value={code} onChange={(evt) => setCode(evt.target.value)}/>
                <Form.Label className="top-label">{t("Security code")}</Form.Label>
            </Form.Group>
            <Button disabled={code.length < 8} className="confirm-button default-button" onClick={handleConfirmation}>{t("Next step")} <Icon size={1} path={ mdiChevronRight } /></Button>
            <Button className="resend-button link-button" onClick={reSendSecurityCode}>{t("Resend security code")}</Button>
            {notification.title.length ? <Notification data={notification} close={() => resetNotification()}/> : null}
        </Container>
    );
};

export default Verification;
